export interface IEmailEngineVariableKeysResponse {
    data: {
        success: boolean;
        message: string;
        results: string[]
    }
}